module.exports = __webpack_public_path__ + "static/r19-2d6b76cb857d0d2614b0963db811e3d0.jpg";